module.exports = __webpack_public_path__ + "static/media/thaihouse_thumb_even.01edf558.webp";